/* ============================================================
   Static UI configuration for Deal Management.
   These are presentation constants (step ids/names, stage colours,
   working labels, analysis progress-task copy) — NOT live application
   data. Live data (deals, investor profile, per-deal step data) comes
   from the backend via ./api.js. Kept separate from data/fixtures.js so
   the fixture/mock dataset is never a source of truth for live screens.
   ============================================================ */

/* Working names pending sign-off (DDM-17). Swap here only. */
export const LABELS = {
	scenarios: 'Stress Test',
	aiceo: 'AI CEO Review',
};

/* Deal workspace steps (order + display names). */
export const STEPS = [
	{ id: 'intake', name: 'Intake' },
	{ id: 'analysis', name: 'Analysis' },
	{ id: 'triage', name: 'Triage' },
	{ id: 'diligence', name: 'Diligence' },
	{ id: 'scenarios', name: LABELS.scenarios },
	{ id: 'memo', name: 'IC memo' },
	{ id: 'decision', name: 'Decision' },
];

/* Pipeline stages — id/name + the Kanban column dot colour (presentation). */
export const STAGES = [
	{ id: 'new', name: 'New', dot: '#FB7785' },
	{ id: 'analysis', name: 'Analysis', dot: '#4A67FF' },
	{ id: 'triage', name: 'Triage', dot: '#FFD34A' },
	{ id: 'diligence', name: 'Diligence', dot: '#4A67FF' },
	{ id: 'ic', name: 'IC & decided', dot: '#4FF786' },
];

/* Analysis progress-task labels (shown while a real run streams over sockets). */
export const PROGRESS_TASKS = [
	'Reading the deck — text, tables and charts',
	'Extracting financials, traction and the ask',
	'Benchmarking market-size claims',
	'Scoring strengths, risks and red flags',
	'Preparing founder questions',
];
